import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let URL = "https://benefacto-backend.developer-ourbase-camp.com/api/";

export const faqsActionApi = createAsyncThunk("faqs/detail", async () => {
	try {
		const { data } = await axios.get(`${URL}faqs/get-faqs`);
		return data;
	} catch (err) {
		return err.message;
	}
});
